<div
	class="app-sidebar"
	[ngClass]="{
		'app-sidebar-collapsed': appMain.sidebarCollapsed && !appMain.isMobile(),
		'app-sidebar-hover-open': appMain.isDesktopHoverOverlay(),
	}">
	<div class="app-sidebar-header">
		<a routerLink="/" class="app-sidebar-logo">
			<img alt="Spyderflow logo darkmode" src="images/spyderflowlogo-header-dark.svg" class="app-logo-img is-dark" />
			<img alt="Spyderflow logo lightmode" src="images/spyderflowlogo-header-light.svg" class="app-logo-img is-light" />
		</a>
		<button
			type="button"
			class="app-sidebar-toggle"
			(click)="appMain.toggleSidebarCollapsed($event)"
			pTooltip="Toggle menu"
			tooltipPosition="right"
			data-testid="sidebarCollapseToggle"></button>
	</div>

	<div class="app-sidebar-menu-wrapper">
		@if (showGlobalSearch()) {
			<app-global-search-bar [collapsed]="appMain.sidebarCollapsed && !appMain.isMobile() && !appMain.isDesktopHoverOverlay()" />
		}
		<ul
			app-submenu
			[item]="model"
			root="true"
			class="app-sidebar-menu"
			visible="true"
			(click)="onMenuClick()"
			[parentActive]="true"
			[collapsed]="appMain.sidebarCollapsed && !appMain.isMobile() && !appMain.isDesktopHoverOverlay()"></ul>
	</div>
</div>
